export const text = {
  pageTitle:    { textStyle: 'd-xxs', color: 'solid.900' },
  sectionTitle: { textStyle: 'h-s',   color: 'solid.900' },
  heading:      { textStyle: 'h-xs',  color: 'solid.900' },
  label:        { textStyle: 'l-xs',  color: 'solid.700' },
  body:         { textStyle: 'b-s',   color: 'solid.700' },
  small:        { textStyle: 'b-xs',  color: 'solid.500' },
  tiny:         { textStyle: 'b-xxs', color: 'solid.500' },
  muted:        { textStyle: 'b-s',   color: 'solid.400' },
}

export const button = {
  primary:   { variant: 'mono',  flex: 1 },
  secondary: { variant: 'white', flex: 1 },
  icon:      { variant: 'ghost', size: 'sm', p: 1 },
}

export const input = {
  form:   { variant: 'forms' },
  search: { variant: 'filterSearch' },
}

export const container = {
  page:    { p: 6 },
  card:    { bg: 'solid.0', borderRadius: '12px', border: '1px solid', borderColor: 'solid.50', p: 4 },
  section: { bg: 'solid.0', p: 4, mb: 4 },
}

export const badge = {
  success: { bg: 'success.0', color: 'success.200' },
  error:   { bg: 'error.0',   color: 'error.100' },
  warning: { bg: 'warning.0', color: 'warning.100' },
  info:    { bg: 'aqua.0',    color: 'aqua.100' },
  neutral: { bg: 'solid.50',  color: 'solid.700' },
}

export const border = {
  divider:  { borderColor: 'solid.50', borderWidth: '1px' },
  section:  { borderBottomColor: 'solid.50', borderBottomWidth: '1px' },
}

/** Colors for skill/task/competence type badges used in classification views */
export const typeTag = {
  skill:      { color: 'pink.100',    bg: 'pink.10',     borderColor: 'pink.10' },
  task:       { color: '#34A853',     bg: '#34A85333',   borderColor: '#34A85333' },
  competence: { color: '#E8A136',     bg: '#E8A13633',   borderColor: '#E8A13633' },
}

export const modal = {
  closeButton: {
    _focus: { outline: 'none', border: 'none', boxShadow: 'none' },
    _hover: { bg: 'solid.50' },
  },
  footer: { height: '72px', gap: 4, borderTopColor: 'solid.50', borderTopWidth: '1px', mt: 3 },
  header: { borderBottomColor: 'solid.50', borderBottomWidth: '1px' },
}
